var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('base-list',{attrs:{"icon":"calendar-alt","title":"Termine"},scopedSlots:_vm._u([{key:"groups",fn:function(){return [_c('dashboard-calendar-absence-list'),_c('dashboard-calendar-birthday-list'),_c('dashboard-calendar-meeting-list'),_c('dashboard-calendar-event-list')]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }